import React, { useCallback, memo } from 'react';
import { SelectOption } from '@leasequery/lq.react-component-library/dist/models';
import {
  ReportCurrency,
  ReportType,
  ClientCustomCalendarModel,
} from '../../../../models';
import * as Styled from '../styled';
import DateRange, {
  DateRangeLabel,
  DateRangeMode,
} from '../date-range/DateRange';
import ReportSettingPIT from '../ReportSettingPIT';
import { ReportTypeSetting } from '../../../../models/reportTypeSetting';
import SplitByDimensionOrAllocation from '../SplitByDimensionOrAllocation';

interface ReportSettingStartEndProps {
  onChange: (updatedValue: ReportSettingStartEndState) => void;
  reportSettingState: ReportSettingStartEndState;
  customCalendarSettings?: ClientCustomCalendarModel;
  reportTypeSetting: ReportTypeSetting;
  isAllowPIT: boolean;
  isAllowSplitByAllocationForReport: boolean;
}

export interface ReportSettingStartEndState {
  selectedCurrency: SelectOption<ReportCurrency>;
  startDate: string;
  rollforwardThrough: string;
  isValid: boolean;
}

function ReportDateSettingStartEnd({
  onChange,
  reportSettingState,
  customCalendarSettings,
  reportTypeSetting,
  isAllowPIT,
  isAllowSplitByAllocationForReport,
}: ReportSettingStartEndProps): JSX.Element {
  const dateRangeLabel: DateRangeLabel = {
    Start: 'Start Date',
    End: 'End Date',
  };
  const handleReportSettingChange = useCallback(
    (state: unknown): void => onChange(state as ReportSettingStartEndState),
    [onChange],
  );

  const mode =
    DateRangeMode[
      customCalendarSettings.isCustomCalendarEnabled
        ? 'CustomCalendar'
        : 'ShortDate'
    ];

  return (
    <>
      <DateRange
        onChange={useCallback(
          (startDate: string, endDate: string, isValid: boolean): void => {
            onChange({
              ...reportSettingState,
              startDate: startDate,
              rollforwardThrough: endDate,
              isValid: isValid,
            });
          },
          [onChange, reportSettingState],
        )}
        startDate={reportSettingState.startDate}
        endDate={reportSettingState.rollforwardThrough}
        mode={mode}
        dateRangeLabel={dateRangeLabel}
        customCalendarPeriods={customCalendarSettings.numberOfPeriods}
      />
      {isAllowPIT && (
        <>
          <Styled.Line />
        </>
      ) }
      <ReportSettingPIT
        reportType={ReportType.startEnd}
        isAllowPIT={isAllowPIT}
        reportSettingState={reportSettingState}
        reportTypeSetting={reportTypeSetting}
        customCalendarSettings={customCalendarSettings}
        onChange={useCallback(
          (state) => onChange(state as ReportSettingStartEndState),
          [onChange],
        )}
      />
      <SplitByDimensionOrAllocation
        reportSettingState={reportSettingState}
        onChange={handleReportSettingChange}
        isAllowSplitByAllocationForReport={isAllowSplitByAllocationForReport}
      />
    </>
  );
}

export default memo(ReportDateSettingStartEnd);
